import { createReducer } from '@reduxjs/toolkit'

import * as sliceActions from '../../actions/Slices/actions'
import * as authenticationActions from '../../actions/Authentication/actions'

import { TSlice } from 'types/GlobalSlice'
import { TFetchStatus } from 'redux/reducers/Dashboards'

export interface ISliceReducerType {
  data: { [sliceId: string]: TSlice }
  fetchStatus: TFetchStatus
}

const INITIAL_STATE: ISliceReducerType = {
  data: {},
  fetchStatus: 'idle'
}

export default createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(sliceActions.getAll, (state) => {
      state.fetchStatus = 'fetching'
    })
    .addCase(sliceActions.getAllSuccess, (state, action) => {
      state.data = {}
      action.payload.forEach((slice) => {
        state.data[slice.id] = slice
      })
      state.fetchStatus = 'success'
    })
    .addCase(sliceActions.getAllFailed, (state) => {
      state.fetchStatus = 'error'
    })
    .addCase(sliceActions.createSuccess, (state, action) => {
      state.data[action.payload.id] = action.payload
    })
    .addCase(sliceActions.updateSuccess, (state, action) => {
      state.data[action.payload.id] = action.payload
    })
    .addCase(sliceActions.destroySuccess, (state, action) => {
      delete state.data[action.payload.id]
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
    .addDefaultCase((state) => state)
})
